import justOnlyLogoFooter from '../../../assets/images/common/logo_footer_just-only.png'
import fightForYouLogoFooter from '../../../assets/images/common/logo_footer_fightforyou.png'
import { getBrand } from '../../../config'
import { Icon } from '../Icon'
import { APP_NAME } from '../../../const'
import React from 'react'
export const LogoFooter = () => {
  if (getBrand() === "fightforyou") {
    return <Icon src={fightForYouLogoFooter} alt={APP_NAME} />
  }
  return <Icon src={justOnlyLogoFooter} alt={APP_NAME} />
}
